module.exports = __webpack_public_path__ + "img/chrome.1619073a.svg";